import React from "react";
import { Carousel, Button } from "react-bootstrap";
import img1 from "../../assets/images/IMG_2881.jpg";
import img2 from "../../assets/images/dv.svg";
import { useNavigate } from "react-router-dom";

const MyCarousel: React.FC = () => {
  const navigate=useNavigate()

const handleApply=()=>{
  navigate('/apply')
}
  return (
    <Carousel fade interval={4000} controls indicators>
      
      {[ 
        {
          img: img1,
          subtitle: "We Are Hiring – VLSI Drive",
          title: "Roles: Design Verification, Physical Design",
          desc: "Trained freshers (before 2021 passed out)",
        },
        {
          img: img1,
          subtitle: "VLSI Career Opportunities",
          title: "Roles: DFT, STA / Synthesis, Analog Layout",
          desc: "Freshers & Experienced Candidates",
        },
      ].map((slide, index) => (
        <Carousel.Item key={index}>
          <div className="carousel-wrapper">
            <img
              className="d-block w-100 carousel-img"
              src={slide.img}
              alt={slide.title}
            />

            <div className="carousel-overlay" />

            <Carousel.Caption className="carousel-content">
              <h6>{slide.subtitle}</h6>
              <h2>{slide.title}</h2>
              <p>{slide.desc}</p>

              <Button className="carousel-btn" onClick={handleApply}>
                APPLY NOW →
              </Button>
            </Carousel.Caption>
          </div>
        </Carousel.Item>
      ))}

    </Carousel>
  );
};

export default MyCarousel;
